module.exports = __webpack_public_path__ + "img/lesson5.f321820a.png";